import * as types from "./types";

export const createCompanyEditRequestRequest = (payload) => ({
  type: types.CREATE_COMPANY_EDIT_REQUEST_REQUEST,
  payload,
});

export const createCompanyEditRequestSuccess = (payload) => ({
  type: types.CREATE_COMPANY_EDIT_REQUEST_SUCCESS,
  payload,
});

export const createCompanyEditRequestFailure = (payload) => ({
  type: types.CREATE_COMPANY_EDIT_REQUEST_FAILURE,
  payload,
});

export const getCompanyEditRequestRequest = (payload) => ({
  type: types.GET_COMPANY_EDIT_REQUEST_REQUEST,
  payload,
});

export const getCompanyEditRequestSuccess = (payload) => ({
  type: types.GET_COMPANY_EDIT_REQUEST_SUCCESS,
  payload,
});

export const getCompanyEditRequestFailure = (payload) => ({
  type: types.GET_COMPANY_EDIT_REQUEST_FAILURE,
  payload,
});

export const updateCompanyEditRequestRequest = (payload) => ({
  type: types.UPDATE_COMPANY_EDIT_REQUEST_REQUEST,
  payload,
});

export const updateCompanyEditRequestSuccess = (payload) => ({
  type: types.UPDATE_COMPANY_EDIT_REQUEST_SUCCESS,
  payload,
});

export const updateCompanyEditRequestFailure = (payload) => ({
  type: types.UPDATE_COMPANY_EDIT_REQUEST_FAILURE,
  payload,
});

export const deleteCompanyEditRequestRequest = (payload) => ({
  type: types.DELETE_COMPANY_EDIT_REQUEST_REQUEST,
  payload,
});

export const deleteCompanyEditRequestSuccess = () => ({
  type: types.DELETE_COMPANY_EDIT_REQUEST_SUCCESS,
});

export const deleteCompanyEditRequestFailure = (payload) => ({
  type: types.DELETE_COMPANY_EDIT_REQUEST_FAILURE,
  payload,
});

export const clearCompanyEditRequest = () => ({
  type: types.CLEAR_COMPANY_EDIT_REQUEST,
});
